import { Injectable } from '@angular/core';

import { SyncUserSettingsService } from '@frontend/sports/user/feature';
import { Decimal } from 'decimal.js';

import { BetslipType } from '../../../../../core/betslip-type';
import { ISlip } from '../../../../bet-generation/models';
import { getSlipBetslipType } from '../../../../bet-generation/services/slip.utils';
import { isBetStationFreebetToken } from '../../../../reward-tokens/services/betstation-reward-tokens.utils';
import { isFreebetToken } from '../../../../reward-tokens/services/reward-tokens.utils';
import { getSlipTotalStakeAndBetCount } from '../../../../summary/services/betslip-summary-helpers';
import { UnderMinimumStakePreCheckError } from '../../../errors/pre-check/under-minimum-stake-pre-check-error';

@Injectable()
export class UnderMinimumStakeValidator {
    constructor(private userSettings: SyncUserSettingsService) {}

    *validate(slip: ISlip): Iterable<UnderMinimumStakePreCheckError> {
        const { totalStake, betCount } = getSlipTotalStakeAndBetCount(slip);
        if (slip.stake == null || isFreebetToken(slip.rewardToken) || isBetStationFreebetToken(slip.rewardToken) || betCount === 0) {
            return;
        }

        const targetBetslipType = getSlipBetslipType(slip);

        if (targetBetslipType === BetslipType.System) {
            const minError = this.validateSystemMin(slip);

            if (!minError) {
                return;
            }

            yield minError;
        } else {
            const minimumStake = new Decimal(this.userSettings.configSettings.minimumStake);
            if (totalStake!.greaterThanOrEqualTo(minimumStake)) {
                return;
            }
            const slipPick = Object.keys(slip.slipPicks)[0];

            const error = new UnderMinimumStakePreCheckError(minimumStake, totalStake!, betCount, slipPick, slip.slipPicks[slipPick].pick.sportId);

            yield error;
        }
    }

    private validateSystemMin(slip: ISlip) {
        const { betCount, stake } = getSlipTotalStakeAndBetCount(slip);
        const minimumStake = this.findSystemMinimum(betCount);
        if (stake!.greaterThanOrEqualTo(minimumStake)) {
            return;
        }
        const slipPick = Object.keys(slip.slipPicks)[0];

        //hard coding bet count to 1 because findSystemMinimum is already taking into account bet counts.

        const error = new UnderMinimumStakePreCheckError(minimumStake.toDecimalPlaces(2), stake!, 1, slipPick, slip.slipPicks[slipPick].pick.sportId);

        return error;
    }

    private findSystemMinimum(betsCount: number): Decimal {
        const count = betsCount;
        const minUnit = new Decimal(this.userSettings.configSettings.minimumStakeSystemUnit);
        const minStakePerBet = new Decimal(this.userSettings.configSettings.minimumStakeSystem / count).toDecimalPlaces(2, Decimal.ROUND_UP);
        const min = minStakePerBet.greaterThanOrEqualTo(minUnit) ? minStakePerBet : minUnit;
        const division = this.getDivision(min, minUnit);

        return division.mul(minUnit).lessThan(min) ? division.plus(1).mul(minUnit) : min;
    }

    private getDivision(divider: Decimal, divident: Decimal): Decimal {
        return divider.toDecimalPlaces(2).dividedToIntegerBy(divident.toDecimalPlaces(2));
    }
}
